export default __webpack_public_path__ + "static/media/Group811.37979297.svg";